"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _effects = require("redux-saga/effects");

var _commonConstants = require("../../../utils/common-constants");

var _action = require("../../notification/action");

var _actions = require("./actions");

var _constants = require("./constants");

var _service = require("./service");

var _marked = /*#__PURE__*/regeneratorRuntime.mark(resourceLabelsWatcher),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(resourceLabelsWorker);

function resourceLabelsWatcher() {
  return regeneratorRuntime.wrap(function resourceLabelsWatcher$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.takeLatest)(_constants.ResourceLabelsType.RESOURCE_LABELS_REQUEST, resourceLabelsWorker);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function resourceLabelsWorker(_ref) {
  var payload, consumerEntityId, params, response, _response$data, _response, reason;

  return regeneratorRuntime.wrap(function resourceLabelsWorker$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref.payload;
          consumerEntityId = payload.consumerEntityId, params = payload.params;
          _context2.prev = 2;
          _context2.next = 5;
          return (0, _effects.put)((0, _actions.resourceLabelsLoading)());

        case 5:
          _context2.next = 7;
          return (0, _effects.call)(_service.fetchResourceLabels, consumerEntityId, params);

        case 7:
          response = _context2.sent;
          _context2.next = 10;
          return (0, _effects.put)((0, _actions.resourceLabelsSuccess)(response));

        case 10:
          _context2.next = 20;
          break;

        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2["catch"](2);
          _response = _context2.t0.response;
          reason = (_response === null || _response === void 0 ? void 0 : (_response$data = _response.data) === null || _response$data === void 0 ? void 0 : _response$data.message) || 'something went wrong';
          _context2.next = 18;
          return (0, _effects.put)((0, _action.openNotification)(_commonConstants.errorNotificationType, reason, true, _commonConstants.errorNotificationDuration));

        case 18:
          _context2.next = 20;
          return (0, _effects.put)((0, _actions.resourceLabelsFailure)(reason));

        case 20:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[2, 12]]);
}

var _default = (0, _effects.all)([(0, _effects.fork)(resourceLabelsWatcher)]);

exports.default = _default;